import { getOptimizedPoints } from "./routes";

export async function getFullWay(data = []) {
    const responseData = [];
    const chunkSize = 49;

    while (data.length > 0) {
        const chunk = data.splice(0, chunkSize);
        const response = await getOptimizedPoints(chunk);

        responseData.push(response);

    }

    return {
        route: {
            flags: { ...(responseData[0]?.route?.flags || {}) },
            legs: responseData.reduce((acc, item) => {
                if (Array.isArray(item.route?.legs)) {
                    acc.push(...item.route.legs);
                }
                return acc;
            }, [])
        }
    };
}